export const nextImageHelper = {
  intrinsic: { maxWidth: '100%', height: 'auto' },
  responsive: { width: '100%', height: 'auto' },
}
